import { render, staticRenderFns } from "./ActorDetailBySetting.vue?vue&type=template&id=7a68722b"
import script from "./ActorDetailBySetting.vue?vue&type=script&lang=js"
export * from "./ActorDetailBySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports